import { Component, Input, OnInit } from '@angular/core';
import { StateAmountOfContribution } from '../../../../features/application/models/amount-of-contribution/amount-of-contribution.model';
import { CompanyType } from '../../../../core/constants/company-type.enum';

@Component({
    selector: 'app-amount-of-contribution-section',
    templateUrl: './amount-of-contribution-section.component.html',
    styleUrls: ['./amount-of-contribution-section.component.scss'],
    standalone: false
})
export class AmountOfContributionSectionComponent implements OnInit {
  @Input() amountOfContribution?: StateAmountOfContribution;
  @Input() opfCode?: CompanyType;

  ngOnInit(): void {
  }

  get roles(): string {
    switch (this.opfCode) {
      case CompanyType.LLP: {
        return "Members";
      }
      case CompanyType.GPA: {
        return "General Partners";
      }
      case CompanyType.LPA: {
        return "Limited Partners";
      }
      case CompanyType.NPI: {
        return "Members";
      }
      case CompanyType.FOU: {
        return "Founders";
      }
      default: {
        return 'Roles';
      }
    }
  }
  
  getExchangeRate(cur: string): number | undefined {
    return this.amountOfContribution?.exchangeRates ? this.amountOfContribution.exchangeRates.find(er => er.currency === cur)?.value : undefined;
  }

  getExchangeDate(cur: string): string | undefined {
    return this.amountOfContribution?.exchangeRates ? this.amountOfContribution.exchangeRates.find(er => er.currency === cur)?.date : undefined;
  }
}